<template>
    <div class="visua-main-box">
        <!-- :chartsVue="false" > 隐藏高级检索栏 -->
        <resultNav :chartsVue="true" @changeTab="changeTab"></resultNav>
        <!-- <div class="charts-title">
            <h2 class="title">知识检索可视化页面</h2>
        </div> -->
        <div :class="tabIndex==1 ? 'charts-main cur' : 'charts-main'">
            <a-spin :spinning="personSpinning" size="large" :wrapperClassName="animateFlag?'aspin cur':'aspin'">
                <div :class="animateFlag ? 'top-box box cur' : 'top-box box'">
                    <div class="taps"><span>人物</span></div>
                    <div class="nav">
                        <span>拖动tag进行排序：</span>
                        <transition-group tag="div" class="container">
                            <div class="item" v-for="(item) in personItems" :key="item.titleEn" 
                                :style="{background:item.color, width:'72px', height:'30px'}"
                                draggable="true" data-code="0"
                                @dragstart="handleDragStart($event, item)"
                                @dragover.prevent="handleDragOver($event, item)"
                                @dragenter="handleDragEnter($event, item)" 
                                @dragend="handleDragEnd($event, item)" >
                                {{item.title}}
                            </div>
                        </transition-group>
                    </div>
                    <div class="content">
                        <div class="facet">
                            <!-- 人物分面 -->
                            <div class="facet-content">{{personItems[0].title}}</div>
                            <div class="facet-person ztree" id="personFacetId"> </div>
                        </div>
                        <!--  :style="{height: '216px'}" -->
                        <div class="graph">
                            <div class="graph-filter">
                                <div class="filter" :class="{ 'cur' : personTitleCode == item.title }" 
                                    v-for="(item, index) in personFilter" :key="index" @click="filterChecked(item, index)">
                                    <a href="javascript:" class="close" @click="close(item, index)" ></a>
                                    <span v-if="index==0">全部{{item.title}}</span>
                                    <span v-else>{{item.title}}</span>
                                </div>

                                <!-- <div class="sort">
                                    <span>排序方式：</span>
                                    <label>
                                        <input type="radio" id="personNameSort" name="personRadio" v-model="personSort" value="0">名称
                                    </label>
                                    <label>
                                        <input type="radio" id="personDescSort" name="personRadio" v-model="personSort" value="1">降序
                                    </label>
                                </div> -->
                            </div>
                            <div class="graph-charts" id="personChart">
                                图表
                            </div>
                        </div>
                    </div>
                </div>
            </a-spin>
            
            <a-spin :spinning="wxSpinning" size="large" :wrapperClassName="animateFlag?'aspin cur':'aspin'">
                <div :class="animateFlag ? 'center-box box cur' : 'center-box box'">
                    <div class="taps"><span>文献</span></div>
                    <div class="nav">
                        <span>拖动tag进行排序：</span>
                        <transition-group tag="div" class="container">
                            <div class="item" v-for="(item) in wxItems" :key="item.titleEn" 
                                :style="{background:item.color, width:'72px', height:'30px'}"
                                draggable="true" data-code="1"
                                @dragstart="handleDragStart($event, item)"
                                @dragover.prevent="handleDragOver($event, item)"
                                @dragenter="handleDragEnter($event, item)" 
                                @dragend="handleDragEnd($event, item)" >
                                {{item.title}}
                            </div>
                        </transition-group>
                    </div>
                    <div class="content">
                        <div class="facet">
                            <!-- 文献分面 -->
                            <div class="facet-content">{{wxItems[0].title}}</div>
                            <div class="facet-wx ztree" id="wxFacetId"> </div>
                        </div>
                        <div class="graph">
                            <div class="graph-filter">
                                <div class="filter" :class="{ 'cur' : wxTitleCode == item.title }" 
                                    v-for="(item, index) in wxFilter" :key="index" @click="filterChecked(item, index)">
                                    <a href="javascript:" class="close" @click="close(item, index)" ></a>
                                    <span v-if="index==0">全部{{item.title}}</span>
                                    <span v-else>{{item.title}}</span>
                                </div>

                                <!-- <div class="sort">
                                    <span>排序方式：</span>
                                    <label>
                                        <input type="radio" id="wxNameSort" name="wxRadio" v-model="wxSort" value="0">名称
                                    </label>
                                    <label>
                                        <input type="radio" id="wxDescSort" name="wxRadio" v-model="wxSort" value="1">降序
                                    </label>
                                </div> -->
                            </div>
                            <div class="graph-charts" id="wxChart">
                                图表
                            </div>
                        </div>
                    </div>
                </div>
            </a-spin>
            
            <a-spin :spinning="eventSpinning" size="large" :wrapperClassName="animateFlag?'aspin cur':'aspin'">
                <div :class="animateFlag ? 'bottom-box box cur' : 'bottom-box box'">
                    <div class="taps"><span>事件</span></div>
                    <div class="nav">
                        <span>拖动tag进行排序：</span>
                        <transition-group tag="div" class="container">
                            <div class="item" v-for="(item) in eventItems" :key="item.titleEn" 
                                :style="{background:item.color, width:'72px', height:'30px'}"
                                draggable="true" data-code="2"
                                @dragstart="handleDragStart($event, item)"
                                @dragover.prevent="handleDragOver($event, item)"
                                @dragenter="handleDragEnter($event, item)" 
                                @dragend="handleDragEnd($event, item)" >
                                {{item.title}}
                            </div>
                        </transition-group>
                    </div>
                    <div class="content">
                        <div class="facet">
                            <!-- 事件分面 -->
                            <div class="facet-content">{{eventItems[0].title}}</div>
                            <div class="facet-event ztree" id="eventFacetId"> </div>
                        </div>
                        <div class="graph">
                            <div class="graph-filter">
                                <div class="filter" :class="{ 'cur' : eventTitleCode == item.title }" 
                                    v-for="(item, index) in eventFilter" :key="index" @click="filterChecked(item, index)">
                                    <a href="javascript:" class="close" @click="close(item, index)" ></a>
                                    <span v-if="index==0">全部{{item.title}}</span>
                                    <span v-else>{{item.title}}</span>
                                </div>

                                <!-- <div class="sort">
                                    <span>排序方式：</span>
                                    <label>
                                        <input type="radio" id="eventNameSort" name="eventRadio" v-model="eventSort" value="0">名称
                                    </label>
                                    <label>
                                        <input type="radio" id="eventDescSort" name="eventRadio" v-model="eventSort" value="1">降序
                                    </label>
                                </div> -->
                            </div>
                            <div class="graph-charts" id="eventChart">
                                图表
                            </div>
                        </div>
                    </div>
                </div>
            </a-spin>
        </div>
    </div>
</template>

<script>
import resultNav from '../../components/resultNav'
import 'ztree/js/jquery.ztree.core.js'
import 'ztree/css/metroStyle/metroStyle.css'
export default {
    name: "visualization",
    components:{
        resultNav
    },
    data() {
        return {
            tabIndex: 0, // 高级检索弹出框显示状态，0：隐藏，1：显示
            dragging: null, // 移动模块
            animateFlag: false,
            personSpinning: false, // 人物-加载中...
            personSort: '0',
            personIndex: 0,
            personTitleCode: '朝代',
            personFilter: [ // 筛选条件
                { title: '朝代', titleEn: "temporal", type: "person" },
            ],
            personItems: [ // 拖拽标签
                { color: '#2e3f7a', title: '朝代', titleEn: "temporal"    , type: "person" },
                { color: '#2e3f7a', title: '籍贯', titleEn: "nativePlace" , type: "person" },
                { color: '#2e3f7a', title: '姓氏', titleEn: "familyName"  , type: "person" },
            ],
            personNode: [ ], // 人物分面数据
            wxSpinning: false, // 文献-加载中...
            wxSort: '0',
            wxIndex: 0,
            wxTitleCode: '文献类型',
            wxFilter: [
                { title: '文献类型', titleEn: "docTypes" , type: "wx" },
            ],
            wxItems: [
                { color: '#2e3f7a', title: '文献类型', titleEn: "docTypes"  , type: "wx" },
                { color: '#2e3f7a', title: '出版时间', titleEn: "time"      , type: "wx" },
                { color: '#2e3f7a', title: '馆藏地'  , titleEn: "heldPlace" , type: "wx" },
                { color: '#2e3f7a', title: '馆藏机构', titleEn: "heldBy"    , type: "wx" },
            ],
            wxNode: [],
            eventSpinning: false, // 事件-加载中...
            eventSort: '0',
            eventIndex: 0,
            eventTitleCode: '年段',
            eventFilter: [
                { title: '年段', titleEn: "twentyYear", type: "event"},
            ],
            eventItems: [
                { color: '#2e3f7a', title: '年段', titleEn: "twentyYear", type: "event"},
                { color: '#2e3f7a', title: '地点', titleEn: "place"     , type: "event"},
                { color: '#2e3f7a', title: '人名', titleEn: "personName", type: "event"}
            ],
            personIsPieChart: false, // 人物切换到饼状图
            wxIsPieChart    : false, // 文献切换到饼状图
            eventIsPieChart : false, // 事件切换到饼状图
            eventNode: [],
            personTreeObj: null,
            wxTreeObj    : null,
            eventTreeObj : null,
            setting:{
                view: {
                    showLine: false,   // 设置 zTree 不显示节点之间的连线
                    nameIsHTML: true, // 设置 name 属性支持 HTML 脚本
                    dblClickExpand: false, //取消默认双击展开父节点的功能
                    showIcon: false,
                    fontCss : {
                        color:"#fff", 
                        background: 'transparent',
                    },
                },
                data: {
                    key: {
                        name: "facet"
                    },
                    simpleData: {
                        enable: true
                    }
                },
                callback: {
                    onClick:  this.zTreeOnClick,    // 分面分类树点击事件
                    onExpand: this.zTreeOnExpand,    // 分面分类树展开事件
                    onNodeCreated: this.zTreeOnNodeCreated // 节点创建后
                }
            },
            myCharts: {},
            xAxisLineData: [],
            seriesLineData: [
                {
                    name: '人物',
                    type: 'line',
                    showBackground: true,
                    data: [120, 132, 101, 134, 90, 230],
                    // lineStyle: { // 线条样式 => 必须使用normal属性
                    //     normal: {
                    //         color: '#8AE09F',
                    //     }
                    // }
                },
            ],
            personOption: {}, // 人物图echarts数据
            wxOption: {},     // 文献图echarts数据
            eventOption: {},  // 事件图echarts数据
            xAxisPersonData: null,
            seriesPersonData: null, 
            xAxisWxData: null,
            seriesWxData: null,
            xAxisEventData: null,
            seriesEventData: null,
            personFacetList: null,  // 人物
            wxFacetList: null,  // 人物
            eventFacetList: null,   // 事件
        }
    },
    mounted(){
        setTimeout(() => {
            this.animateFlag = true;
        }, 100);
        this.$nextTick(()=>{
            // this.$loading.show("加载中...");
            this.getVisualization(); // 可视化——人物
            this.getWxVisualization(); // 可视化——文献
            this.getEventVisualization(); // 可视化——事件
        })
    },
    methods: {
        getVisParams(){ // 获取路由中传递的可视化参数
            let _visParams = {};
            let routeParams = this.$route.params;
            if( !this.isEmptyObject(routeParams) && !this.isEmpty(routeParams.visParams) ){
                _visParams = JSON.parse(decodeURIComponent(routeParams.visParams));
            }
            return _visParams;
        },
        setVisualizations(items){ // 设置接口中visualizations 参数值
            let visualizations = [];
            for(let i=0, len=items.length; i<len; i++){
                visualizations.push(items[i].titleEn);
            }
            return visualizations;
        },
        getVisualization: async function(){ // 可视化——人物
            this.personSpinning = true; // 加载中...
            let params = this.$qs.parse(localStorage.wxResultVisParams);
            if(!params) params = {};
            params.visualizations = this.setVisualizations(this.personItems);
            await this.$axios.post( this.Common.getMrPersonVisualizationUrl, params )
            .then((res) => {
                let resultData  = res.data;
                if(!this.isEmptyObject(resultData.data)) {
                    this.personFacetList = resultData.data.facet[0];
                    this.setFacetNode("person", this.personFacetList);
                }
                this.personSpinning = false; // 加载中...
            })
            .catch((err) => {
                console.log(err)
            });
        },
        getWxVisualization: async function(){ // 可视化——文献
            this.wxSpinning = true; // 加载中...
            let params = this.$qs.parse(localStorage.wxResultVisParams);
            if(!params) params = {};
            params.visualizations = this.setVisualizations(this.wxItems);
            await this.$axios.post( this.Common.getDocVisualizationUrl, params )
            .then((res) => {
                let resultData  = res.data;
                if(!this.isEmptyObject(resultData.data)) {
                    this.wxFacetList = resultData.data.facet[0];
                    this.setFacetNode("wx", this.wxFacetList);
                }
                this.wxSpinning = false; // 加载中...
            })
            .catch((err) => {
                console.log(err)
            });
        },
        getEventVisualization: async function(){ // 可视化——事件
            this.eventSpinning = true; // 加载中...
            let params = this.$qs.parse(localStorage.wxResultVisParams);
            if(!params) params = {};
            params.visualizations = this.setVisualizations(this.eventItems);
            await this.$axios.post( this.Common.getEventVisualizationUrl, params )
            .then((res) => {
                let resultData  = res.data;
                if(!this.isEmptyObject(resultData.data)) {
                    this.eventFacetList = resultData.data.facet[0];
                    this.setFacetNode("event", this.eventFacetList);
                }
                this.eventSpinning = false; // 加载中...
            })
            .catch((err) => {
                console.log(err)
            });
        },
        setFacetNode(str, facetList){ // 分面数据设置
            let _node    = str+'Node';    // 分面标签变量
            let _items   = str+'Items';   // 拖拽标签变量
            let _filter  = str+'Filter';  // 筛选条件
            this[_node] = [];
            // if(!this.isEmptyObject(facetList)){
                let firstTitleEn  = this[_items][0].titleEn; // 第一条标题
                let secondTitleEn = this[_items][1].titleEn; // 第二条标题
                let firstDataArr  = facetList[firstTitleEn]; // 第一条数据
                for(let i=0, len=firstDataArr.length; i<len; i++){
                    let getData = firstDataArr[i];
                    getData.type        = str;
                    getData.titleEn     = firstTitleEn;
                    let secondData      = getData[secondTitleEn];
                    if(!this.isEmptyArray(secondData)) {
                        getData.isParent    = true;
                        getData.childrenArr = secondData;
                    }
                    this[_node].push(getData);
                }
                // 筛选条件，第一条数据存放
                this[_filter][0].childrenArr = firstDataArr;
            // }
            // 分面加载
            this.zTreeInit(str, this[_node]);

            // 加载可视化图形
            let seriesObj = {
                childrenArr: firstDataArr,
                facet: firstTitleEn,
                type: str
            };
            this.setSeriesData(seriesObj);
        },
        seriesDataInit(){ // 初始化图形数据
            this.seriesLineData = [];
            this.xAxisLineData  = [];
        },
        setSeriesData(data){
            this.seriesDataInit();
            let _type        = data.type;
            let _facet       = data.facet;
            let _childrenArr = data.childrenArr;
            let dataArr      = [];
            for(let i=0, len=_childrenArr.length; i<len; i++){
                dataArr.push(_childrenArr[i].count);
                this.xAxisLineData.push(_childrenArr[i].facet);
            }
            let nameData = this.getTtileBYTitleEn(data);
            // if(this.isEmpty(nameData)) nameData = _facet;
            // 线图
            this.seriesLineData.push({
                name: nameData,
                type: 'line',
                showBackground: true,
                data: dataArr
            });
            
            let _isPieChart  = _type + 'IsPieChart';
            this[_isPieChart] = false; // 判断是否切换到饼状图
            let chartId = _type + 'Chart';
            this.setChartGraph(_type, this.setLineOption);
            this.magicTypeChanged(_type);
            this.setRestore(_type);
            this.chartsResize();
        },
        close(item, index){
            event.stopPropagation(); // 阻止冒泡 --> 让外层不影响内层事件
            if(index == 0) return;
            let _type         = item.type;// titleEn
            let _titleCodeKey = _type + 'TitleCode';
            let _filterKey    = _type + 'Filter';
            this[_filterKey].splice(index, 1);
            let _lastFilterIndex = this[_filterKey].length-1;
            // 选中筛选数据中最后一个
            this[_titleCodeKey] = this[_filterKey][_lastFilterIndex].title;
            // 加载可视化图形
            this.setSeriesData(this[_filterKey][_lastFilterIndex]);
        },
        filterChecked(item, index){ // 筛选条件选中
            let _type         = item.type;
            let _titleCodeKey = _type + 'TitleCode';
            let _filterKey    = _type + 'Filter';
            let _title        = this[_filterKey][index].title;
            if(this[_titleCodeKey] == _title) return;
            this[_titleCodeKey] = _title;
            // 加载可视化图形
            this.setSeriesData(item);
        },
        getTtileBYTitleEn(data){ // 获取图形名字
            let _title = '';
            let obj = {
                temporal    :'朝代',
                nativePlace :'籍贯',
                familyName  :'姓氏',
                docTypes    :'文献类型',
                time        :'出版时间',
                heldPlace   :'馆藏地',
                heldBy      :'馆藏机构',
                author      :'责任者',
                twentyYear  :'年段',
                place       :'地点',
                personName  :'人名'
            }
            if(data.facet){
                _title = obj[data.facet] ? obj[data.facet] : data.facet;
            }
            else {
                _title = data.title;
            }
            return _title;
        },
        zTreeInit(str, zNodes){ // 初始化树状分面
            let _facetIdKey = str + 'FacetId';
            let _treeObjKey = str + 'TreeObj';
            $.fn.zTree.init($("#"+_facetIdKey), this.setting, zNodes);
            this[_treeObjKey] = $.fn.zTree.getZTreeObj(_facetIdKey);
        },
        zTreeOnClick(event, treeId, treeNode){ // 分类树点击
            if(!treeNode.isParent) {
                $("#"+treeNode.tId+"_a").css({ "opacity": "1" });
                $("#"+treeNode.tId).css({ "pointer-events": "none" });
                return;
            }
            let _type           = treeNode.type;
            let _filterKey      = _type + 'Filter';
            let _titleCodeKey   = _type + 'TitleCode';
            this[_titleCodeKey] = treeNode.facet ? treeNode.facet : treeNode.name;
            // 可视化和筛选条件设置
            this.setSeriesAndFilter(treeNode, _filterKey);
        },
        zTreeOnExpand(event, treeId, treeNode){ // 分类树展开
            let _type           = treeNode.type;
            let _filterKey      = _type + 'Filter';
            let _itemsKey       = _type + 'Items';
            let _titleCodeKey   = _type + 'TitleCode';
            let _treeObjKey     = _type + 'TreeObj';
            let _level          = treeNode.level;
            this[_titleCodeKey] = treeNode.facet ? treeNode.facet : treeNode.name;
            // 获取当前节点tId
            var zTreeNodeTId = treeNode.tId;
            // 获取当前节点下的子节点
            var treeNodeChildren = treeNode.children;
            if(this.isEmptyArray(treeNodeChildren)){
                let zNodesNew = []; // 新子节点数据
                // 获取子节点数据
                let _childrenArr = treeNode.childrenArr;
                let nowNode = this[_treeObjKey].getNodeByTId(zTreeNodeTId);
                for(let i=0, len=_childrenArr.length; i<len; i++){
                    let _childrenData  = _childrenArr[i];
                    _childrenData.type = _type;
                    let _itemsTitleEn  = this[_itemsKey][_level+2];
                    if(_itemsTitleEn && !this.isEmptyArray(_childrenData[_itemsTitleEn.titleEn])) {
                        _childrenData.isParent    = true;
                        // _childrenData.nextTitleEn = _itemsTitleEn.titleEn;
                        _childrenData.titleEn     = this[_itemsKey][_level].titleEn;
                        _childrenData.childrenArr = _childrenData[_itemsTitleEn.titleEn];
                    }
                    zNodesNew.push(_childrenData);
                }
                // 展开二级分类树
                this[_treeObjKey].addNodes(nowNode, zNodesNew);
            }
            // 可视化和筛选条件设置
            this.setSeriesAndFilter(treeNode, _filterKey);
        },
        zTreeOnNodeCreated(event, treeId, treeNode){ // 节点创建后
            let _nodeId = '#'+treeNode.tId + '_a';
            if(treeNode.count){
                let _span = "<span>(" + treeNode.count + ")</span>";
                $(_nodeId).append(_span);
            }
        },
        setSeriesAndFilter(treeNode, filterKey){
            let _titleEn = treeNode.titleEn;
            if(this.hasOwnObject(treeNode, this[filterKey])) {
                // 加载可视化图形
                this.setSeriesData(treeNode);
                return
            }
            var obj = new Object();
            obj.color       = '#222f60';
            // obj.title   = this.getTtileBYTitleEn(_titleEn);
            obj.title       = treeNode.facet ? treeNode.facet : treeNode.name;
            obj.titleEn     = treeNode.titleEn;
            obj.childrenArr = treeNode.childrenArr;
            // obj.nextTitleEn = treeNode.nextTitleEn;
            obj.type        = treeNode.type;
            this[filterKey].push(obj);
            // 加载可视化图形
            this.setSeriesData(treeNode);
        },
        hasOwnObject(treeNode, arr){ // 判断数组中是否含有某个对象的值
            let flag   = false;
            let _title = treeNode.facet ? treeNode.facet : treeNode.name;
            for(let i=0, len=arr.length; i<len; i++){
                let item = arr[i];
                if(item.title == _title){
                    flag =  true;
                    break;
                }
            }
            return flag;
        },
        handleDragStart(e, item){
            this.dragging = item;
        },
        handleDragEnd: async function(e, item){ // 标签移动结束
            this.dragging = null
            let _type = item.type;
            // 重新检索数据
            if(_type == "person") await this.getVisualization();
            if(_type == "wx")     await this.getWxVisualization();
            if(_type == "event")  await this.getEventVisualization();
        },
        //首先把div变成可以放置的元素，即重写dragenter/dragover
        handleDragOver(e) {
            //在dragenter中针对放置目标来设置!
            e.dataTransfer.dropEffect = 'move';
        },
        handleDragEnter(e, item){
            e.dataTransfer.effectAllowed = "move";
            // 为需要移动的元素设置dragstart事件
            if(item === this.dragging) return;
            let _type      = item.type;
            let _itemsKey  = _type + "Items";
            let _filterKey = _type + "Filter";
            let _titleCodeKey   = _type + 'TitleCode';
            const newItems = [...this[_itemsKey]];
            const src = newItems.indexOf(this.dragging);
            const dst = newItems.indexOf(item);
    
            newItems.splice(dst, 0, ...newItems.splice(src, 1));
            this[_itemsKey]  = newItems;
            // 条件只留一个
            this[_filterKey] = newItems.slice(0, 1);
            // this[_filterKey] = newItems.slice(0, this[_filterKey].length);
            // 拖动后选中第一个标签
            this[_titleCodeKey] = this[_filterKey][0].title;
        },
        setChartGraph(type, option){
            let _tag = type + 'Chart';
            let myChart = this.$echarts.init(document.getElementById(_tag));
            myChart.setOption(option);
            this.myCharts[type] = myChart;
            // window.onresize = this.myChart.resize;
        },
        chartsResize(){ // echarts随屏幕变化自适应
            window.onresize = ()=>{
                for(let key in this.myCharts){
                    this.myCharts[key].resize();
                }
            }
        },
        magicTypeChanged(type){ //工具栏点击事件重写
            var _this = this;
            // 工具栏，图例切换事件
            _this.myCharts[type].on('magictypechanged', function(obj) {
                // let seriesLen = obj.newOption.series.length;
                let _isPieChart  = type + 'IsPieChart'; // 判断是否饼状图
                if(_this[_isPieChart]){
                    this.clear();
                    _this[_isPieChart] = false;
                    let _optionKey = type + 'Option';
                    let getOption = _this[_optionKey];
                    if(obj.currentType == 'line'){
                        _this.setLine(getOption);
                        this.setOption(getOption, true)
                    }
                    if(obj.currentType == 'bar'){
                        _this.setBar(getOption);
                        this.setOption(getOption, true)
                    }
                }
            })
        },
        setRestore(type){ // 还原
            var _this = this;
            _this.myCharts[type].on('restore', function(obj) {
                let _isPieChart  = type + 'IsPieChart'; // 判断是否饼状图
                if(_this[_isPieChart]){ // 饼状图时还原
                    _this[_isPieChart] = false;
                    let _optionKey = type + 'Option';
                    let getOption  = _this[_optionKey];
                    this.clear();
                    _this.setLine(getOption);
                    this.setOption(getOption, true);
                }
                else { // 非饼状图还原
                    let _getOption = _this.myCharts[type].getOption();
                    let _series = _getOption.series[0];
                    if(_series.type == 'bar'){
                        _series.type = 'line';
                        _getOption.xAxis[0].boundaryGap = false;
                        this.clear();
                        this.setOption(_getOption, true);
                    }
                }
            })
        },
        clearOptionData(option){ // 清理数据
            option.title  = [];
            option.xAxis  = [];
            option.yAxis  = [];
            option.grid   = [];
            option.series = [];
            option.legend = [];
        },
        setOptionLegend(option){ // echarts 设置 legend 属性
            option.legend = [];
            option.legend.push({
                textStyle: {
                    color: "#fff"
                }
            });
        },
        setOptionGrid(option){ // echarts 设置 grid 属性
            option.grid = [];
            option.grid.push({ // 直角坐标系内绘图网格
                show: false, // 是否显示直角坐标系网格。
                left: '3%',
                right: '12%',
                bottom: '3%',
                containLabel: true,
                borderColor: '#fff'
            });
        },
        setOptionXAxis(option, data){ // echarts 设置 xAxis 属性
            option.xAxis = [];
            option.xAxis.push({ // x坐标
                type: 'category',
                boundaryGap: data.boundaryGap, // 坐标轴两边留白策略
                data: data.xAxisData,
                axisLine: {
                    show: true,
                    lineStyle: { // x坐标轴颜色 和 宽度
                        color: '#fff',
                        width: 1,
                    }
                }
            });
        },
        setOptionYAxis(option){ // echarts 设置 yAxis 属性
            option.yAxis = [];
            option.yAxis.push({ // y坐标
                type: 'value',
                splitLine: { // 去掉默认的线
                    show: false
                },
                axisLine: {
                    // show: true,
                    lineStyle: { // y坐标轴颜色 和 宽度
                        color: '#fff',
                        width: 1,
                    }
                }
            })
        },
        setOptionSeries(option, data){ // echarts 设置 series 属性
            option.series = [];
            option.series.push({  // seriesLineData
                name: data.name,
                type: data.graphType, // 'line'
                showBackground: true,
                data: data.dataArr
            });
        },
        setData(option){
            let _dataArr   = [];
            let _xAxisData = [];
            let _series    = option.series[0];
            _series.data.forEach(item => {
                _dataArr.push(item.value);
                _xAxisData.push(item.name);
            })
            let data = {
                name: _series.name,
                graphType: '',
                dataArr: _dataArr,
                xAxisData: _xAxisData
            }
            return data;
        },
        setLine(option){ // 线状图配置
            let data = this.setData(option);
            data.graphType   = 'line';
            data.boundaryGap = false;
            this.setOptionLegend(option);
            this.setOptionGrid(option);
            this.setOptionXAxis(option, data);
            this.setOptionYAxis(option);
            this.setOptionSeries(option, data);
        },
        setBar(option){ // 柱状图配置
            let data = this.setData(option);
            data.graphType   = 'bar';
            data.boundaryGap = true;
            this.setOptionLegend(option);
            this.setOptionGrid(option);
            this.setOptionXAxis(option, data);
            this.setOptionYAxis(option);
            this.setOptionSeries(option, data);
        },
        setPie(option, data){
            option.legend.push({
                type: 'scroll',
                orient: 'horizontal', // 图例列表的布局朝向 horizontal/vertical
                left: 'center',
                data: data.legendData,
                selected: data.legendSelected,
                textStyle: { // 文字颜色
                    color: '#fff',
                },
                pageIconColor: '#fff',
                pageTextStyle: { // 翻页数字颜色
                    color: '#fff', 
                }
            });
            option.series.push({
                name: data.name,
                type: 'pie',
                radius: '55%',
                center: ['50%', '60%'],
                data:  data.dataArr,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            });
        },
        setPieData(option){ // 饼状图数据设置
            let pieDataArr = [];
            let legendData = [];
            let legendSelected = {};
            let _xAxis  = option.xAxis[0];
            let _series = option.series[0];
            for(let i=0, len=_xAxis.data.length; i<len; i++){
                let _xAxisData  = _xAxis.data[i];
                let _seriesData = _series.data[i];
                legendData.push(_xAxisData);
                legendSelected[_xAxisData] = true;
                pieDataArr.push({
                    value: _seriesData,
                    name:  _xAxisData
                });
            }
            this.clearOptionData(option);
            let data = {
                name: _series.name,
                dataArr: pieDataArr,
                legendData: legendData,
                legendSelected: legendSelected
            };
            this.setPie(option, data);
            return option;
        },
        setMyToolsPie(o, el){ // 自定义饼状图点击
            let _getOption = o.getOption();
            if(_getOption.series && _getOption.series[0].type != "pie"){
                let _chartTag = $(el.getDom()).get(0).id;
                let _getPieOption = this.setPieData(_getOption);
                this.chartsTagFlag(_chartTag, _getPieOption); // 点击饼状图后，各模块图形数据储存
                let pieChart = this.$echarts.init(document.getElementById(el.getDom().id));
                pieChart.clear();
                pieChart.setOption(_getPieOption);
                //还原刷新
                // pieChart.dispatchAction({ type: 'restore' })
            }
        },
        chartsTagFlag(chartTag, option){ // 点击饼状图后，各模块图形数据储存
            let _type = chartTag.slice(0, chartTag.length-5);
            let _isPieChart   = _type + 'IsPieChart'; // 判断是否饼状图
            let _optionKey    = _type + "Option";
            this[_optionKey]  = option;
            this[_isPieChart] = true; // 是否切换为饼状图
        },
        changeTab(tabIndex){
            this.tabIndex = tabIndex;
        }
    },
    computed: {
        setLineOption(chartTag){ // 折线图配置
            return {
                title: {
                    id: "lineOption",
                    // text: '人物分析图',
                    textStyle: {
                        color: "#fff"
                    }
                },
                tooltip: { // 提示框
                    trigger: 'item', // 'item':数据项图形触发 'axis':坐标轴触发 'none':什么都不触发
                },
                legend: { // 图列组件
                    // data: ['唐朝', '宋朝', '元朝', '明朝', '清朝', '民国'],
                    textStyle: {
                        color: "#fff"
                    }
                },
                grid: { // 直角坐标系内绘图网格
                    show: false, // 是否显示直角坐标系网格。
                    left: '3%',
                    right: '12%',
                    bottom: '3%',
                    containLabel: true,
                    borderColor: '#fff'
                },
                toolbox: { // 工具栏
                    show: true,
                    orient: 'vertical',// 'horizontal': 横向
                    showTitle: true, // 工具名显示
                    left: 'right',
                    top: 'middle', // 'top', 'middle', 'bottom', 20xp, 20%
                    zlevel: 2,
                    feature: {
                        magicType: { // 动态切换图形
                            type: ['line', 'bar'],
                            iconStyle: {
                                borderWidth: 1,
                                borderColor: 'RGB(62,152,197)', // #3e98c5
                            },
                            emphasis: {
                                iconStyle: {
                                    borderWidth: 1,
                                    // borderColor: '#666'
                                }
                            },
                        },
                        myToolsPie: { // 自定义饼状图
                            show: true,
                            title: "切换为饼状图",
                            text: '切换为饼状图',
                            iconStyle: {
                                borderWidth: 1,
                                borderColor: 'RGB(62,152,197)', // #3e98c5
                            },
                            emphasis: {
                                iconStyle: {
                                    borderWidth: 1,
                                    // borderColor: '#666'
                                }
                            },
                            // 路径：下载或复制SVG，将标签中所有d属性拼接起来
                            icon: 'path://M486.2444 72.8023v444.309504c0 1.3097 0.4997 2.6214 1.4991 3.6198 1.0004 1.0004 \
                                        2.3101 1.5002 3.6209 1.5002H949.7190400000001c0 238.0882-199.9575 421.3412-438.6222 \
                                        421.3412-238.677 0-432.1485-186.5452-432.1485-424.6323C78.9484 280.8402 251.9009 72.8023 \
                                        486.2444 72.8023z,M542.422 44.713c238.6637 0 435.3853 183.253 435.3853 421.3402H547.542016c-1.3097 \
                                        0-2.6214-0.4997-3.6198-1.4991-1.0004-1.0004-1.5002-2.3101-1.5002-3.6209V44.71296z',
                            onclick: (o, el)=>{
                                this.setMyToolsPie(o, el);
                            }
                        },
                        // dataZoom: { // 数据区域缩放
                        //     yAxisIndex: "none"
                        // },
                        // dataView: { // 数据视图工具，可以展现当前图表所用的数据，编辑后可以动态更新
                        //     readOnly: false
                        // },
                        restore: {
                            show: true,
                            title: '还原',
                            iconStyle: {
                                borderColor: '#ff3333'
                            },
                            emphasis: {
                                iconStyle: {
                                    borderColor: '#ff3333' //鼠标悬浮工具时颜色
                                }
                            }
                        },
                        saveAsImage: {
                            show: true,
                            title: '保存为图片',
                            backgroundColor: '#222f60', // 保存的图片背景色
                            iconStyle: {
                                borderColor: 'orange'
                            },
                            emphasis: {
                                iconStyle: {
                                    borderColor: 'orange' //鼠标悬浮工具时颜色
                                }
                            }
                        }
                    },
                    emphasis: {
                        iconStyle: { // 所有工具数据悬浮时样式
                            borderWidth: 2,
                            textPosition: 'left', // 文本位置 'left' / 'right' / 'top' / 'bottom'
                            // textAlign: 'left' // 文本对齐方式 'left' / 'center' / 'right'
                        }
                    }
                },
                xAxis: { // x坐标
                    type: 'category',
                    boundaryGap: false, // 坐标轴两边留白策略
                    data: this.xAxisLineData,
                    axisLine: {
                        // show: true,
                        lineStyle: { // x坐标轴颜色 和 宽度
                            color: '#fff',
                            width: 1,
                        }
                    }
                },
                yAxis: { // y坐标
                    type: 'value',
                    splitLine: { // 去掉默认的线
                        show: false
                    },
                    axisLine: {
                        // show: true,
                        lineStyle: { // y坐标轴颜色 和 宽度
                            color: '#fff',
                            width: 1,
                        }
                    }
                },
                series: this.seriesLineData,
                textStyle: {
                    color: "#fff"
                }
            }
        }
    },
    watch: {
        
    }
}
</script>

<style lang="less">
.visua-main-box{
    margin: 0;
    padding: 0;
    background: #19234b;
    width: 100%;
    min-height: calc(100vh);
    color: #fff;
    .charts-title{
        width: 80vw;
        margin: auto;
        .title{
            margin: 0;
            padding: 20px 0 0 15px;
            // display: inline-block;
            color: #fff;
        }
    }
    .charts-main{
        width: 80vw;
        // background: #2e3f7a;
        margin: auto;
        padding: 15px 15px 60px 15px;
        position: relative;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        // opacity: 0;
        // transform: scale(0);
        // transition: opacity 0.2s, transform 0.5s;
        &.cur{
            opacity: 0.1;
        }
        .aspin{
            margin-bottom: 10px;
            transform: scale(0);
            transition: opacity .2s .2s, transform .5s .2s;
            &.cur{
                opacity: 1;
                transform: scale(1);
            }
            .ant-spin-container{
                &.ant-spin-blur{
                    border-radius: 5px;
                }
            }
            .top-box{
                transform: scale(0);
                transition: opacity .2s .2s, transform .5s .2s;
                &.cur{
                    opacity: 1;
                    transform: scale(1);
                }
            }
            .center-box{
                transform: scale(0);
                transition: opacity .2s .3s, transform .5s .3s;
                &.cur{
                    opacity: 1;
                    transform: scale(1);
                }
            }
            .bottom-box{
                transform: scale(0);
                transition: opacity .2s .4s, transform .5s .4s;
                &.cur{
                    opacity: 1;
                    transform: scale(1);
                }
            }
            .box{
                position: relative;
                padding: 10px;
                background: #2e3f7a;
                // background: #222f60;
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
                border-bottom-left-radius: 5px;
                .taps{
                    position: absolute;
                    width: 40px;
                    top: 0;
                    left: -40px;
                    span{
                        display: block;
                        width: 40px;
                        padding: 10px;
                        box-sizing: border-box;
                        border-bottom-left-radius: 5px;
                        // background: #222f60;
                        background: #2e3f7a;
                        border-top-left-radius: 5px;
                        cursor: pointer;
                    }
                }
                .nav{
                    width: 95%;
                    height: 40px;
                    line-height: 40px;
                    margin: auto;
                    background: #222f60;
                    border-radius: 5px;
                    text-align: center;
                    position: relative;
                    span{
                        // width: 72px;
                        line-height: 40px;
                        // background: #2e3f7a;
                        margin: auto 10px;
                        float: left;
                        // display: inline-block;
                        // border-radius: 5px;
                    }
                    .container{ // 元素拖拽样式
                        // width: 80px;
                        // height: 300px;
                        position: absolute;
                        left: 0;
                        display: contents;
                        flex-direction: column;
                        padding: 0;
                        .item {
                            width: 72px;
                            line-height: 30px;
                            margin-top: 10px;
                            transition: all linear .3s;
                            display: inline-block;
                            border-radius: 5px;
                            margin: auto 5px;
                            cursor: pointer;
                        }
                    }
                }
                .content{
                    width: 95%;
                    margin: 10px auto;
                    overflow: hidden;
                    .facet{
                        width: 18%;
                        min-height: 216px;
                        max-height: 390px;
                        background: #222f60;
                        border-radius: 5px;
                        padding: 10px;
                        // text-align: center;
                        display: inline-block;
                        overflow-y: auto;
                        // .facet-content{
                        //     margin-top: 20px;
                        // }
                        .ztree{ // 被选中节点透明度
                            li{
                                a{
                                    &.curSelectedNode{
                                        opacity: 0.6;
                                    }
                                }
                            }
                        }
                    }
                    // 滚动条样式
                    .facet::-webkit-scrollbar {
                        width: 6px;
                        height: 6px;
                    }
                    .facet::-webkit-scrollbar-thumb {
                        border-radius: 10px;
                        -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
                        box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
                        background: rgba(255, 255, 255, 0.4);
                    }
                    .facet::-webkit-scrollbar-track {
                        -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
                        box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.4);
                        border-radius: 5px;
                        background: rgba(255, 255, 255, 0.2);
                    }
                    .graph{
                        width: 80%;
                        border-radius: 5px;
                        // background: #222f60;
                        float: right;
                        .graph-filter {
                            .filter{
                                line-height: 30px;
                                min-width: 140px;
                                background: #3755c3; // 2e3f7a 1563b7
                                border-top-left-radius: 5px;
                                border-top-right-radius: 5px;
                                display: inline-block;
                                text-align: center;
                                position: relative;
                                border: 1px solid #222f60;
                                cursor: pointer;
                                &.cur{
                                    background: #222f60;
                                }
                                span{
                                    margin-right: 30px;
                                    margin-left: 10px;
                                }
                                .close {
                                    position: absolute;
                                    width: 30px;
                                    height: 30px;
                                    line-height: 30px;
                                    top: 0;
                                    right: 0;
                                    content: "";
                                    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjdCN0M3QjkzQkY0MDExRUE4Q0Q2RTY0Mzg2NTNGMDM0IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjdCN0M3Qjk0QkY0MDExRUE4Q0Q2RTY0Mzg2NTNGMDM0Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0I3QzdCOTFCRjQwMTFFQThDRDZFNjQzODY1M0YwMzQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0I3QzdCOTJCRjQwMTFFQThDRDZFNjQzODY1M0YwMzQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz76nY3gAAAA80lEQVR42oySMQ4BQRSGZydLhFblAi6gUqEjXAMRNxCdM1DaAyg1FGxBp5HoRKdDorEKCf4ns8lkvN3Zl3ybzM78X2bejDP1vKIQIg+2InmlQAXsJD59sAET4CQIZ8ECLEGJBENwAF0wtkgoPAdVsAY+Ce6glkBihpvgJdXkxSJJM+GAJqS2KEpC4RkXpnKNbYaSlZKQoABaXJgTmJKO+seGzSPo9QBXbXwET26hG9Nteii+emRt8AY98IkTcFeV03oiTIm0hAPVkzo4cVcsLeGwzupIfxISZCzhOMlPMEgQjpKUSbAHI9CwhHVJWe3g9hVgANsiUQECTgSgAAAAAElFTkSuQmCC);
                                    background-repeat: no-repeat;
                                    background-size: 10px;
                                    background-position: center 50%;
                                    z-index: 666;
                                }
                            }
                            .sort{
                                float: right;
                                label{
                                    margin: auto 5px;
                                    input{
                                        -webkit-appearance: auto;
                                    }
                                }
                            }
                        }
                        .graph-charts {
                            height: 390px;
                            background: #222f60;
                            border-bottom-left-radius: 5px;
                            border-bottom-right-radius: 5px;
                            border-top-right-radius: 5px;
                        }
                    }
                }
            }
        }
    }
}
</style>